import { Container, Row, Col, Tab, Nav, Carousel } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/Imagen2.jpg";
import projImg2 from "../assets/img/Imagen3.jpg";
import projImg3 from "../assets/img/Imagen10.jpg";
import projImg4 from "../assets/img/Imagen1.png";
import projImg5 from "../assets/img/capture500.png";
import projImg6 from "../assets/img/luis.ca0d153.png";
import meter1 from "../assets/img/js.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Bonne et Filou",
      description: "Website Development about Shop for Pets",
      imgUrl: projImg1,
    },
    {
      title: "Stader Labs",
      description: "Stader Labs is a liquid staking platform for earnings liquid staking rewards across crypto tokens",
      imgUrl: projImg2,
    },
    {
      title: "NFT White Rabbit",
      description: "Creating and launching a unique NFT collection, managing the entire process from conceptualization to implementation on the blockchain",
      imgUrl: projImg3,
    },
    {
      title: "Cyber",
      description: "A Blast-native Dex built for traders",
      imgUrl: projImg4,
    },
    {
      title: "Fenix",
      description: "Fenix is a decentralized exchange (DEX) that provides deep spot and perpetuals trading markets on Blast",
      imgUrl: projImg5,
    },
    {
      title: "Quantum Frenzy",
      description: "Web3 Game staking on an NFT project Psychokitties",
      imgUrl: projImg6,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Portfolio</h2>
                <p>Throughout my career, I have worked on a variety of key projects in the technology arena:

                 <p>- Web development: Creation of interactive and responsive sites using HTML, CSS, AWS, Python, React, Next.js, Vue.js and JavaScript.</p> 

                  <p>- NFT projects: Development of platforms for the creation and management of non fungible tokens (NFT) with smart contract integration.</p>

                  <p>- Decentralized Exchanges (DEX): Design and development of DEX, ensuring secure and efficient transactions and integration.</p> 
                  
                  <p>- Staking: Implementation of solutions that allow users to participate in staking through smart contracts.</p> 

                  <p>- Blockchain Architecture: Design of blockchain networks and systems that improve traceability and security.</p> 
                  
                  <p>- Smart Contracts Audits: Conducting audits to identify vulnerabilities and ensure the integrity of smart contracts.</p> 
                </p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Portfolio</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">2</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p></p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p><a href="https://www.fenixfinance.io/"> Fenix </a>: I worked on the implementation of smart contracts in the Blockchain Blast, ensuring their correct integration with the decentralized application (DEX) and external systems, allowing me to design customized solutions that automate workflows, reduce costs and ensure transparency in every interaction.  
                      
                      <p><a href="https://crypto.com/nft/collection/faa3d8da88f9ee2f25267e895db71471"> Quantun Frenzy a Game of Psychokitties project</a>: I designed the staking protocol and blockchain architecture for an innovative GameFi (Game Finance) project built on the Polygon network.  
                      </p>
                      </p>
                      <p>
                      <a href="https://cyberblast.io/"> Cyber</a>: Design and development of an AI Agent on the Layer 2 Blast network. This protocol not only facilitates the creation and implementation of AI agents, but also enables their monetization within the blockchain ecosystem. 
                      Issuance: Comparison between programmed inflation and token burning. Distribution: Percentages allocated to the team, community and investors
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p><a href="https://staderlabs.com/"> Stader Labs</a>: Designed and developed smart contracts to be implemented in the blockchain network according to the requirements of Hedera, Fantom, Terra, Near, Polygon. I was also in the smart contract audit team and Dapp frontend team where some updates were made.  
                      </p>
                      <p>
                      <a href="https://rabbitff.com/"> NFT project White Rabbit</a>: • Blockchain architecture design patterns and supporting infrastructure.
                        • Creation of Dapp, Smart Contracts and ERC721 together with a deep knowledge of EVM.
                      </p>
                      <p>
                      <a href="https://bonneetfilou.com/"> Bonne et Filou</a>: • Database and website development and supervision.
                      • Managed the network system, including performance management, capacity monitoring, and system upgrades.
                      </p>
                      <p>
                      <a href="https://www.sbevolutionlandscape.com/"> SB Evolution Landscape</a>: • Development and supervision of web services, app and database.
                      • Design studies that address user behavior.
                      • Manage and maintain the entire operation and services of the AWS infrastructure.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
